<template>

  <div class="selectPartnerUniWrapper" v-show="options">

    <select v-model="selected"
            class="custom-select"
            v-bind:class="{ 'is-invalid': !isValid }"
            :disabled="readonly">
      <option
        v-for="option in options"
        v-bind:value="option"
        v-bind:key="option.id">
        {{ option.name }}
      </option>
    </select>
    <div class="invalid-feedback" v-if="invalidMessage">
      {{invalidMessage}}
    </div>

  </div>

</template>

<script>

  import axios from 'axios';
  axios.defaults.withCredentials = true;

  export default {

    name: 'select-partner-universitaet',
    props: {
      partnerUniversitaet: {
        type: Object,
        required: false
      },
      invalidMessage: {
        type: String,
        required: false
      },
      readonly: null
    },
    data () {
      return {
        /** mögliche Unis */
        options: null,
        /** vom User ausgewählte Uni */
        selected: null
      }
    },
    mounted: function () {

      this.init();
      if (this.partnerUniversitaet && this.partnerUniversitaet.id) {
        this.selected = this.partnerUniversitaet;
      }

    },
    watch: {

      /** Uni wurde von aussen übergeben */
      partnerUniversitaet: function (val) {
        this.selected = val;
      },
      /** partnerUniversitaet wurde vom Benutzer ausgewählt */
      selected: function (val) {
        this.emit(val);
      }

    },
    computed: {

      /** prüft ob das Bundesland eingegeben wurde */
      isValid: function () {

        if (!this.selected || !this.selected.id) {
          return false;
        }
        return true;

      }

    },
    methods: {

      init: function() {

        var that = this;

        // hole alle Länder:
        var url  = process.env.VUE_APP_SERVER_URL + '/partnerUniversitaet';
        var params = {
          bewerbung_id: this.getBewerbung()
        }
        axios.get(url, {
          params: params,
          withCredentials: true
        })
        .then(function (response) {

          that.options = response.data;

          // ist was vorbelegt?
          that.checkExisting();

        });

      },
      checkExisting: function() {

        console.log('prüfe existierende ' + this.partnerUniversitaet);
        if (this.partnerUniversitaet && this.options) {

          for (var i = 0; i < this.options.length; i++) {
            if (this.options[i].id === this.partnerUniversitaet.id) {
              this.selected = this.options[i];
              break;
            }
          }

        }

      },
      /** emit Uni */
      emit: function(val) {

        if (val) this.selected = val;
        this.$emit('set-partner-universitaet', this.selected);

      }

    }

  }

</script>
